import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-10 px-4" data-id="element-151">
      <div className="max-w-xl mx-auto text-center" data-id="element-152">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-black text-brand-navy mb-4" data-id="element-153">
          Der wahre versteckte Preis
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-base sm:text-lg text-brand-muted leading-relaxed font-medium mb-4" data-id="element-154">
          Hör auf, mit deiner Freizeit zu bezahlen.
        </motion.p>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-base sm:text-lg text-brand-text leading-relaxed" data-id="element-155">
          Mehr als{' '}
          <span className="text-brand-red font-bold" data-id="element-156">
            120 Stunden pro Saison
          </span>{' '}
          verloren. Jede Stunde manuelle Vorbereitung kostet dich{' '}
          <span className="text-brand-navy font-bold" data-id="element-157">150 bis 300 CHF</span> an
          entgangenen Einnahmen. Das sind Wochenenden und Abende die nicht
          zurückkommen.
        </motion.p>
      </div>
    </section>;
}